import { decamelize } from 'shared/lib';

export const transformRequest = [
  (data: unknown) => {
    if (data instanceof FormData) return data;
    return JSON.stringify(decamelize(data));
  },
];
